/**
 * Handles the functionality for the facets menu in the shop interface.
 * Manages the opening/closing of filters menu and related UI interactions.
 * @function facetsMenu
 */
const facetsMenu = () => {
  $('html.js .no_submit').click(function (e) {
    e.preventDefault();
  });
  $(
    '.open_filters,.facets-menu__close,.facets__submit,.facets__reset,.form-menu__mask'
  ).click(function () {
    $('#open_filters_menu').toggleClass('show_menu');
    $('body').toggleClass('overflow-hidden');
    $('body').toggleClass('open-filters');
    $('.shopify-section-header').toggleClass('low_index');
    $('.section-announcement').toggleClass('low_index');
  });
};

/**
 * Initializes the facets menu functionality when the DOM is fully loaded.
 */
document.addEventListener('DOMContentLoaded', function () {
  facetsMenu();
});

/**
 * Reinitializes the facets menu functionality when a Shopify section is loaded.
 */
document.addEventListener('shopify:section:load', function () {
  facetsMenu();
});

let menu = document.querySelector('.facets-menu');

/**
 * Adds click event listener to sort by dropdown to toggle rotation of SVG icon.
 */
if (document.querySelector('.select__sort_by')) {
  document
    .querySelector('.select__sort_by')
    .addEventListener('click', function () {
      document
        .querySelector('.facets__sort-by svg')
        .classList.toggle('rotateSvg');
    });
}
